import {getApp, initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {environment} from "../../../../../environments/environment";
import {getFirestore, provideFirestore} from "@angular/fire/firestore";
import {FIREBASE_OPTIONS} from "@angular/fire/compat";

const FIREBASE_PROVIDERS = [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore(getApp(), 'talenlio-db')), {
        provide: FIREBASE_OPTIONS,
        useValue: environment.firebase
    }
]

export {FIREBASE_PROVIDERS};

